function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import { AbstractDomainData } from "nood-comp/src/net/AbstractDomainData";
export var OrgData = /*#__PURE__*/_createClass(function OrgData() {
  var _this = this;
  _classCallCheck(this, OrgData);
  this.should_return = false;
  this.must_return = function (flag) {
    _this.should_return = flag;
    return _this;
  };
  this.one = function (id, setter, errors, cb) {
    var t = _this;
    AbstractDomainData.one("org", id, function (response) {
      var _response$error;
      if (response.data) {
        setter(response.data);
        cb === null || cb === void 0 || cb(response);
      }
      if (((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.length) > 0) {
        errors(response.error);
        cb === null || cb === void 0 || cb(response);
        setter({});
      }
    });
  };
  this.put = function (id, obj, set_success, set_errors, cb) {
    AbstractDomainData.put("org/".concat(id), obj, function (response) {
      var _response$http;
      if ((response === null || response === void 0 || (_response$http = response.http) === null || _response$http === void 0 ? void 0 : _response$http.code) === 200) {
        set_success(response.success);
        cb === null || cb === void 0 || cb(response);
      } else {
        set_errors(response.error);
        cb === null || cb === void 0 || cb(response);
      }
    });
  };
  this.post = function (obj, set_success, set_errors, cb) {
    AbstractDomainData.post("org", obj, function (response) {
      var _response$http2;
      if ((response === null || response === void 0 || (_response$http2 = response.http) === null || _response$http2 === void 0 ? void 0 : _response$http2.code) === 200) {
        set_success(response.success);
        cb === null || cb === void 0 || cb(response);
      } else {
        set_errors(response.error);
        cb === null || cb === void 0 || cb(response);
      }
    });
  };
});